module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/bottom-img.008555c1.png";